import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';



const HtmlValidationErrorsRender = ({ htmlErrors = [] }) => {
  const intl = useIntl();

  return (
    <div className="html-validation-errors">
      {htmlErrors.length > 0 && (
        <ul className="error-list">
          {htmlErrors.map((error, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className="error-item">
              <div className="error-content">
                <div className="error-message">{error.message}</div>
                {error.details && (
                  <div className="error-details">{error.details}</div>
                )}
                {error.element && (
                  <div className="error-element">
                    {`${intl.formatMessage({ id: 'templates-visualizations-html-problem-element-error' })}:`}
                    <code>{error.element}</code>
                  </div>
                )}
                {error.position.line && (
                  <div className="error-position">
                    {`${intl.formatMessage({ id: 'templates-visualizations-html-problem-element-row-error' })}: ${error.position.line}`}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

HtmlValidationErrorsRender.propTypes = {
  htmlErrors: PropTypes.array,
};

export default HtmlValidationErrorsRender;
